import React from 'react';
import {render} from 'react-dom';
import Modal from 'react-modal';
import ScrollAnimate from '../components/ScrollAnimate';
import data from './data';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};
class Card extends React.Component{
  constructor() {
  super();

  this.state = {
    modalIsOpen: false
  };

  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
}

openModal() {
  this.setState({modalIsOpen: true});
}

afterOpenModal() {
  // references are now sync'd and can be accessed.
  this.subtitle.style.color = '#f00';
}

closeModal() {
  this.setState({modalIsOpen: false});
}
  render(){
    const {title, pic, items} = this.props;
    return(
      <section className="column align-middle small-6 large-3 services-home-card">
        <article className="card-wrapper services-home-card__wrapper">
            <section onClick={this.openModal}>
              <header className="services-home-card__heading">
                <h4 className="text-center">{title}</h4>
              </header>
              <figure className="align-self-middle margin-top-default">
                <img src={pic} className="services-home-card__images"/>
              </figure>
            </section>
            <Modal
              isOpen={this.state.modalIsOpen}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              style={customStyles}
              contentLabel="Services Modal"
            >
            <span className="closeBtn" onClick={this.closeModal}>close</span>
            <section className="services-home-card__content">
              <header className="row services-card__heading-wrapper">
                <h3 className="text-center services-card__heading">{title}</h3>
              </header>
              <section className="services-card__content">
                <ul className="services-card__text">
                  {items.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
              </section>
            </section>
          </Modal>
        </article>
      </section>
    );

  }
}

const Services = () => {
  return(
      <section>
        <h2 className="text-center">Our Services</h2>
       <ScrollAnimate offsetHeight={650} animateClass="home-services-animate">
          <article className="row align-spaced">
            {data.map((item, index) =>
              <Card key={index} {...item} />
            )}
          </article>
        </ScrollAnimate>
      </section>
  );
};
export default Services;



// WEBPACK FOOTER //
// ./src/HomePage/Services.js